import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowIcon } from '../icons';

// About-ASG intro paragraph + corner-detail image. Lives after the
// products block so the page leads with the product range, then
// explains the company. All three copy fields are admin-editable.
export default function IntroSection({ settings }) {
  return (
    <section className="asg-intro">
      <div className="asg-reveal">
        <p className="asg-section-label">{settings.intro_label ?? 'About ASG'}</p>
        <h2 className="asg-section-title">
          {settings.intro_title ?? 'Shading solutions that define the space between indoors and out.'}
        </h2>
        <p className="asg-section-body">
          {settings.intro_body ?? 'We design and supply fully customisable pergola systems that extend your living space, and we deliver our retractable awning range free across Melbourne metro. Every structure is engineered to order - matching the precision of modern architecture with materials built for the Australian climate.'}
        </p>
        <Link to="/about" className="asg-link">
          Learn more <ArrowIcon />
        </Link>
      </div>
      <div className="asg-intro-img asg-reveal">
        <img src="/uploads/gallery/about-asg-pergola-corner-detail.webp" alt="Close-up detail of a matte charcoal aluminium louvered pergola corner - ASG Shading Melbourne" width={1254} height={1254} loading="lazy" />
      </div>
    </section>
  );
}
